import { altTextTitle } from './imageAltText.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';
import RibbonPlugin from '../../plugin/RibbonPlugin';
import { lazyShowImageAltTextDialog } from 'owa-editor-ribbon-secondary-ui';
import { setImageAltText } from 'roosterjs-editor-api';
import { QueryScope } from 'roosterjs-editor-types';

const imageAltText: RibbonButton = {
    key: 'imageAltText',
    title: () => loc(altTextTitle),
    imageSrc: require('../svg/imagealttext.svg'),
    buttonState: formatState =>
        formatState.canAddImageAltText ? RibbonButtonState.Normal : RibbonButtonState.Disabled,
    onExecute: showImageAltTextDialogForSelection,
};

export default imageAltText;

async function showImageAltTextDialogForSelection(plugin: RibbonPlugin) {
    let editor = plugin.getEditor();
    let range = editor.getSelectionRange();
    let nodeSelectedByPlugin = plugin.getImageSelectedByPlugin();
    let node = nodeSelectedByPlugin || editor.queryElements('img', QueryScope.OnSelection)[0];

    lazyShowImageAltTextDialog.import().then(showImageAltTextDialog =>
        showImageAltTextDialog(node, alt => {
            editor.select(range);
            if (nodeSelectedByPlugin) {
                nodeSelectedByPlugin.alt = alt;
            } else {
                setImageAltText(editor, alt);
            }
        })
    );
}
